export const Color = {
  PRIMARY: '#004bc4',
  PRIMARY_DARK: '#00307e',
};

export { setup as setupCssAdapter } from './adapters/css';
